fx.ns("filters", class ProductMediaFilter extends fx.Filter {

	constructor(mediaType, target)
	{
        super();

        this._mediaType = mediaType;
        this._target = target || "";
    }

    get mediaType()
    {
        return this._mediaType;
    }

    set mediaType(val)
    {
        this._mediaType = val;
        this._changed = true;
        this.trigger("updated");
    }

    get target()
    {
        return this._target;
    }

    set target(val)
    {
        this._target = val;
        this._changed = true;
        this.trigger("updated");
    }

    exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];

        let rawData = this.rawData.filter( (a) => a.model ==  this.mediaType && a.media).sort( (a, b) => a.position - b.position);
        
        for (let i = 0; i < rawData.length; i++)
        {
            let productMedia = rawData.getItemAt( [i] );

            //if (productMedia.model != this.mediaType || !productMedia.media)
                //continue;

            if (this.target && productMedia.media.target != this.target)
                continue;

            this.transformedData.push( productMedia.media );
        }

		return this.transformedData;
	}	

    
});